/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { ISetting } from "../../models/Settings/SettingContract";

export const SETTINGS_TIMEOUT_TITLE = 'Prompt the user if they want to stay logged in, if they have been inactive for the following amount of time';
export const SETTINGS_WARNING_TITLE = 'Display the prompt this amount of time before user is logged out';
export const DEFAULT_INACTIVITY_MINS = 60;
export const DEFAULT_WARNING_MINS = 1;
export const DEFAULT_APP_LISTING_PERMISSION = false;
export const DEFAULT_IDP_ROLE_MAPPING_PERMISSION = false;
export const DEFAULT_ISOLATION_PERMISSION = false;
export const MINUTES = 'minute(s)';
export const SETTINGS_SUCCESS_MESSAGE = "Realm settings saved successfully.";
export const INACTIVITY_TIMEOUT = 'inactivityTimeout';
export const TIMEOUT_WARNING = 'timeoutWarning';
export const ISOLATION_ENABLED = 'enableLocationSegregation';
export const MAX_LENGTH_VALIDATION = 5;
export const NUMBER_REGEXP = /^\d*$/;
export const MINUTES_GREATER_THAN_ZERO_ERROR_MSG = 'Please provide a value greater than zero';
export const TIMEOUT_VALIDATION_ERROR_MSG = 'Timeout warning must be less than activity timeout';
export const ERROR_FETCHING_SETTINGS = 'There was an error while fetching settings: {0}';
export const ERROR_SAVING_SETTINGS = 'There was an error while saving settings: {0}';
export const formDefaultValues: ISetting = {
    id: '',
    realmId: "",
    inactivityTimeout: DEFAULT_INACTIVITY_MINS,
    timeoutWarning: DEFAULT_WARNING_MINS,
    enableAppListingPermissions: DEFAULT_APP_LISTING_PERMISSION,
    enableIdpRoleMapping: DEFAULT_IDP_ROLE_MAPPING_PERMISSION,
    [ISOLATION_ENABLED]: DEFAULT_ISOLATION_PERMISSION
};
export const INACTIVITY_TIMEOUT_HEADING = 'Inactivity Timeout';
export const ACCESS_APP_LISTINGS_TITLE = 'Access level (RBAC) required for user to view each app';
export const APP_LISTING_TITLE = 'App Listing';
export const ENABLE_APP_LISTINGS = 'enableAppListingPermissions';
export const ENABLE_IDP_ROLE_MAPPING = 'enableIdpRoleMapping';
export const IDP_ROLE_MAPPING_PERMISSION_TITLE = 'Customer admins can map their Identity Providers roles to Blue Yonder roles';
export const IDP_ROLE_MAPPING_TITLE='Role Mapping';
export const ISOLATION = 'Enable Sub Realms';
export const ISOLATION_TITLE = 'Allow sub-realm segregation with in a realm';
export const BY_USER_STORE_TITLE = 'Blue Yonder User Store';
export const BY_USER_STORE_DESC = 'Enable Blue Yonder user store';
export const ENABLE_BY_USER_STORE = 'enableByUserStore';
export const ERROR_IN_FETCHING_IDENTITY_PROVIDERS = 'There is some problem in fetching Identity Provider, please contact your system administrator.';
export const PASSWORD_POLICY = 'passwordPolicy';
export const PASSWORD_POLICY_LABEL = 'Password Policy';
export const MFA_ACTIVE = 'mfaActive';
export const MFA_ACTIVE_LABEL = 'Enable multi-factor authentication (MFA)';
export const MFA_DISABLE_WARN_MSG = 'Disabling Multi-factor Authentication (MFA) for Blue Yonder User Store will allow users created in the Blue Yonder User Store to log in to this realm without requiring a second authentication factor. To retain MFA, click Cancel. To proceed with disabling MFA, click Save.';
export const PASSWORD_POLICY_INFO = 'To manage the password policies, click on the Password Policy tab. If Password Policy tab is not visible, please contact your system administrator.';
export const IDP_DISABLE_WARN_MSG = 'Disabling this option will block user sign-ins. Users created in Blue Yonder User store will no longer be able to log in to this realm. Click Cancel to keep the option enabled, or click Save to confirm disabling it.';
export const INACTIVITY_TIMEOUT_CARD = 'inactivity-timeout-card';
export const APP_LISTING_CARD = 'app-listing-card';
export const ROLE_MAPPING_CARD = 'role-mapping-card';
export const SEGREGATION_CARD = 'segregation-card';
export const USER_STORE_CARD = 'user-store-card';
export const BY_USER_STORE_ALERT = 'Blue Yonder user store enable/disable may take 2 hrs to reflect on login.';
export const NATIVE_CAMEL_CASE= 'Native';
export const NATIVE_UPPER_CASE= 'NATIVE';
export const LOCAL_CAMEL_CASE= 'Local';
export const B2C_IDP_ID = 'b2cIdpId';